import { DEFAULT_TRUE_VARIABLES, ENV_VARIABLE_IDS } from './constants';
import type { FeatureFlags } from './types';

export function coerceIntoBoolean(value: boolean | 'true' | 'false') {
  if (typeof value === 'boolean') {
    return value;
  }
  return value === 'true';
}

export function selectFeatureFlags(
  envVars: Record<string, boolean | 'true' | 'false'> | undefined,
) {
  return ENV_VARIABLE_IDS.reduce((acc, key) => {
    const value = envVars?.[key] ?? (DEFAULT_TRUE_VARIABLES.includes(key) ? 'true' : 'false'); // by default ff's are assumed to be false
    acc[key] = coerceIntoBoolean(value);
    return acc;
  }, {} as FeatureFlags);
}
